<template>
    <div class="switch" :class="{'open': this.value, 'close': !this.value}" @click="onClick">
        <div class="oval"></div>
    </div>
</template>

<script>
    export default {
        name: 'PSwitch',
        props: {
            value: {
                default: false,
                type: Boolean,
            },
            enable: {
                default: true,
                type: Boolean,
            }
        },
        methods: {
            onClick() {
                if (!this.enable) return;
                this.$emit('input', !this.value);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .switch {
        min-height: 20px;
        min-width: 45px;
        border-radius: 10px;
        padding: 2px;
        box-sizing: border-box;
        display: flex;

        &.open {
            background-color: rgba(51,153,51,1);
            flex-flow: row-reverse;
        }

        &.close {
            background-color: rgba(187,187,187,1);
        }

        .oval {
            width: 40%;
            padding-top: 40%;
            background-color: rgba(255,255,255,1);
            border-radius: 90%;
        }
    }
</style>
